<template>
  <article class="flex flex-col">
    <div class="mb-[120px] flex gap-[20px]">
      <div class="flex flex-col xl:w-3/4 2xl:w-4/5">
        <div class="mb-[65px] flex flex-col lg:flex-row">
          <CommonBlocksImageArticleBlock
            v-if="audioLecture?.data?.value?.image"
            class="mb-4 lg:mb-0 lg:mr-[32px]"
            is-social
            is-lecture
            :data="audioLecture?.data?.value"
            :published-at="audioLecture?.data?.value?.published_at"
            :src="audioLecture?.data?.value?.image?.src"
          />
          <div class="flex w-full flex-col lg:w-2/3">
            <h1
              class="mb-[28px] text-[32px] font-medium leading-[38px]"
              v-text="audioLecture?.data?.value?.title"
            />
            <div
              class="page-body mb-4"
              v-html="audioLecture?.data?.value?.description"
            />
            <AudioBar
              v-if="audioLecture?.data?.value?.path"
              :file-path="audioLecture?.data?.value?.path"
              :course="audioLecture?.data?.value"
              class="mt-auto"
            />
          </div>
        </div>
        <CommonBlocksNewTagsBlock
          v-if="tags"
          class="mb-[80px]"
          v-bind="{ tags }"
        />
        <ClientOnly>
          <div
            v-if="audioLecture?.data?.value?.authors?.length"
            class="flex flex-col"
          >
            <h3 class="mb-[36px] text-[24px] font-medium">Автор</h3>
            <div class="grid grid-flow-row gap-5">
              <CommonAuthorInfo
                v-for="author in audioLecture.data.value.authors"
                :key="author.id"
                :author="author"
              />
            </div>
          </div>
        </ClientOnly>
      </div>
      <CommonBlocksRightArticleBlock class="xl:w-1/4 2xl:w-1/5" />
    </div>
    <!-- <CommonCommentsBlock
      :comments="audioLecture?.data?.value?.comments"
      :model-type="audioLecture?.data?.value?.model_type"
      :model-id="audioLecture?.data?.value?.id"
    /> -->
    <CommonBlocksPageFooterBlocks />
  </article>
</template>

<script setup>
const route = useRoute();
const slug = route?.params?.slug;
const { audioLecture } = useAudioLecturesBySlug(slug);
const tags = audioLecture?.data?.value?.tags;

const robots = ref('all');
const seo = ref({});
seo.value = audioLecture?.data?.value?.seo;

useHead({
  title: `${
    audioLecture?.data?.value?.title
      ? audioLecture?.data?.value?.title + ' |'
      : ''
  } Слушать аудиолекции по истории РФ для школьников и студентов`,
  meta: [
    {
      hid: 'description',
      name: 'description',
      content: `${
        seo.value?.metadescription ?? audioLecture?.data?.value?.title ?? ''
      }. Слушать аудиолекции по истории РФ для школьников и студентов на сайте Федерального портала истории России.`,
    },
    {
      hid: 'keywords',
      name: 'keywords',
      content: audioLecture?.data?.value?.title ?? '',
    },
    {
      'http-equiv': 'Last-Modified',
      content: new Date(seo.value?.last_modified).toUTCString(),
    },
    {
      hid: 'robots',
      name: 'robots',
      content: robots.value,
    },
  ],
});
/*
import AudioBar from '@/components/Audio/AudioBar';
import AuthorInfo from '@/components/Common/AuthorInfo';
import ImageArticleBlock from '@/components/Common/Blocks/ImageArticleBlock';
import NewTagsBlock from '@/components/Common/Blocks/NewTagsBlock';
import PageFooterBlocks from '@/components/Common/Blocks/PageFooterBlocks';
import RightArticleBlock from '@/components/Common/Blocks/RightArticleBlock';
import CommentsBlock from '@/components/Common/Comments/CommentsBlock';
import api from '@/services/api/api';

export default {
  components: {
    PageFooterBlocks,
    RightArticleBlock,
    AuthorInfo,
    NewTagsBlock,
    CommentsBlock,
    AudioBar,
    ImageArticleBlock,
  },

  layout: 'marginless',

  async asyncData({ route, error }) {
    try {
      const slug = route.params.slug;
      const { data } = await api.lectures.getAudioLectureBySlug(slug);

      let robots;
      const seo = data?.data?.seo;
      if (seo) {
        const arr = [];
        if (seo.index === false) arr.push('noindex');
        if (seo.follow === false) arr.push('nofollow');
        if (seo.archive === false) arr.push('noarchive');
        if (arr.length > 0) {
          robots = arr.reduce((previousValue, currentValue) => {
            return `${previousValue}, ${currentValue}`;
          });
        }
      }

      return {
        data: data?.data,
        tags: data?.data?.tags,
        comments: data?.data?.comments,
        seo: seo ?? {},
        robots: robots ?? 'all',
      };
    } catch (e) {
      console.log(e);
      error({ statusCode: e.response?.status ?? 503 });
    }
  },

  data() {
    return {
      data: {},
      tags: [],
      comments: [],
      seo: {},
      robots: 'all',
    };
  },

  head() {
    return {
      title: `${this.data?.title} | Слушать аудиолекции по истории РФ для школьников и студентов`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `${
            this.seo.metadescription ?? this.data.title
          }. Слушать аудиолекции по истории РФ для школьников и студентов на сайте Федерального портала истории России.`,
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: `${this.data?.title}`,
        },
        {
          'http-equiv': 'Last-Modified',
          content: new Date(this.seo?.last_modified).toUTCString(),
        },
        {
          hid: 'robots',
          name: 'robots',
          content: this.robots,
        },
      ],
    };
  },
};*/
</script>
